export default __webpack_public_path__ + "static/media/c_10.c84462b6.svg";